export default __webpack_public_path__ + "static/media/G0390.ChronicObstructivePulmonaryDisease-updated130623sb_GS.1692719220000.695fac03.jpg";